import React from 'react';
import { Divider, Skeleton } from 'antd';
import { NoChatHistoryIcon, StarIcon } from 'icons';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { globalConst, isEmptyArr } from 'modules/global';

import { Visible } from 'components';

import { ITestRating } from '../models';

interface IProps {
  data: ITestRating[] | undefined;
  loading: boolean;
}

const TestFikrlar = ({ data, loading }: IProps) => {
  const t = useTranslations();

  return (
    <>
      <div className="scrollbar-custom max-h-58 min-h-58 overflow-auto pr-2">
        <Visible
          if={loading}
          else={
            <Visible
              if={isEmptyArr(data)}
              else={
                <div>
                  <div className="mb-3 text-xs font-medium text-gray-500">{t('fikrlar')}</div>
                  {data?.map((user, index) => (
                    <div key={user.id} className="flex w-full gap-1">
                      <Link href={`${globalConst.pageNames.CABINET}/${user.profile_id}`}>
                        <div className="flex-shrink-0">
                          <Image
                            src={user.image || '/images/default-user.png'}
                            alt="DEFAULT"
                            width={28}
                            height={28}
                            loading="lazy"
                            title='Foydalanuvchining default rasmi'
                            className="max-h-7 min-h-7 rounded-full object-cover"
                          />
                        </div>
                      </Link>
                      <div className="w-full">
                        <div className="flex items-center justify-between">
                          <Link href={`${globalConst.pageNames.CABINET}/${user.id}`}>
                            <div className="font-medium text-black">{user.name}</div>
                          </Link>
                          <div className="flex gap-1">
                            {[...Array(5)].map((_, index) => (
                              <StarIcon
                                // eslint-disable-next-line react/no-array-index-key
                                key={index}
                                size="12"
                                color={index < user.rating ? 'text-orange-400' : 'text-gray-200'}
                              />
                            ))}
                          </div>
                        </div>
                        <p className="mt-1 flex-shrink-0 text-xs text-gray-500">{user.comment}</p>
                        {index !== data.length - 1 && <Divider className="!my-2" />}
                      </div>
                    </div>
                  ))}
                </div>
              }
            >
              <div className="flex h-40 items-center justify-center sm:col-span-3">
                <div className="flex w-full flex-col items-center justify-center">
                  <NoChatHistoryIcon />
                  <span className="ml-5 mt-4 text-gray-500">{t('fikrlar_topilmadi')}</span>
                </div>
              </div>
            </Visible>
          }
        >
          {Array.from({ length: 1 }).map((_, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={index} className="flex w-full gap-3">
              <div className="flex-shrink-0">
                <Skeleton.Avatar className="!h-6 !w-6" active />
              </div>
              <div className="w-full">
                <div className="flex items-center justify-between">
                  <Skeleton.Button active className="!w-30 mt-1 !h-3" />
                  <Skeleton.Button active className="!w-30 mt-1 !h-3" />
                </div>
                <Skeleton.Input active className="mt-2 !h-2 !w-full" />
                <Skeleton.Input active className="!w-50 !h-2" />
              </div>
            </div>
          ))}
        </Visible>
        {/* {loading ? (
          Array.from({ length: 1 }).map((_, index) => (
            <div key={index} className="flex w-full gap-3">
              <div className="flex-shrink-0">
                <Skeleton.Avatar className="!h-6 !w-6" active />
              </div>
              <div className="w-full">
                <div className="flex items-center justify-between">
                  <Skeleton.Button active className="!w-30 mt-1 !h-3" />
                  <Skeleton.Button active className="!w-30 mt-1 !h-3" />
                </div>
                <Skeleton.Input active className="mt-2 !h-2 !w-full" />
                <Skeleton.Input active className="!w-50 !h-2" />
              </div>
            </div>
          ))
        ) : (data || []).length <= 0 ? (
          <div className="flex h-40 items-center justify-center sm:col-span-3">
            <div className="flex w-full flex-col items-center justify-center">
              <NoChatHistoryIcon />
              <span className="ml-5 mt-4 text-gray-500">{t('fikrlar_topilmadi')}</span>
            </div>
          </div>
        ) : (
          <div>
            <div className="mb-3 text-xs font-medium text-gray-500">{t('fikrlar')}</div>
            {data?.map((user, index) => (
              <div key={user.id} className="flex w-full gap-1">
                <div className="flex-shrink-0">
                  <Image
                    src={user.image || '/images/default-user.png'}
                    alt="DEFAULT"
                    width={28}
                    height={28}
                    loading="lazy"
                    className="max-h-7 min-h-7 rounded-full object-cover"
                  />
                </div>
                <div className="w-full">
                  <div className="flex items-center justify-between">
                    <div className="font-medium">{user.name}</div>
                    <div className="flex gap-1">
                      {[...Array(5)].map((_, index) => (
                        <StarIcon
                          key={index}
                          size="12"
                          color={index < user.rating ? 'text-orange-400' : 'text-gray-200'}
                        />
                      ))}
                    </div>
                  </div>
                  <p className="mt-1 flex-shrink-0 text-xs text-gray-500">{user.comment}</p>
                  {index !== data.length - 1 && <Divider className="!my-2" />}
                </div>
              </div>
            ))}
          </div>
        )} */}
      </div>
    </>
  );
};

export default TestFikrlar;
